export const MainSolutionKey = [
  "Quality",
  "Manufacturing",
  "Logbooks",
  "Clinical",
  "Product Development",
  "Regulatory",
  "Supplier",
  "Post-Market",
  "Asset Management",
] as const;

export type MainSolutionKey = (typeof MainSolutionKey)[number];


export type MainSolutionOptionsObject = {
  readonly [Key in MainSolutionKey]: string;
};